import Vue from 'vue'
const state = {
  timerTrackings: null
}

const getters = {
  allTrackings: (state) => state.timerTrackings
}

const actions = {
  setTimerTrackings ({ commit }, timerTrackings) {
    commit('SET_TIMER_TRACKINGS', timerTrackings)
  },
  updateStoppedTrackings ({ commit }, stoppedTrackings) {
    commit('UPDATE_STOPPED', stoppedTrackings)
  }
}

const mutations = {

  SET_TIMER_TRACKINGS (state, timerTrackings) {
    state.timerTrackings = null
    state.timerTrackings = timerTrackings
  },
  UPDATE_STOPPED (state, stoppedTrackings) {
    if (stoppedTrackings !== null && stoppedTrackings.length > 0) {
      stoppedTrackings.forEach(tracking => {
        let currentTracking = state.timerTrackings.find(f => f.checkListId === tracking.checkListId)

        if (currentTracking && currentTracking !== null) {
          Vue.set(currentTracking, 'lastStatus', null)
          Vue.set(currentTracking, 'lastStatus', 2)
        }
      })
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
